export const defaultMiscellaneousBanners = {
  timer: {
    backgroundImage:
      'https://assets.roguefitness.com/image/upload/v1614175281/Rogue%20App%20Dashboard/rogue-gym-timer-banner_lbpduv.png',
    buttonText  : 'View Rogue Timer Remote',
    description : 'Use your mobile device as a Rogue Timer Remote for timed workouts.',
    header      : 'Rogue Timer Remote',
    routeName   : 'HomeTimer',
  },
  theindex: {
    backgroundImage:
      'https://assets.roguefitness.com/image/upload/v1614175356/Rogue%20App%20Dashboard/profile-the-index-bg_aqdkce.png',
    buttonText: 'View The Index',
    description:
      'A knowledge base of product and movement information, lifestyle content and strength history.',
    header  : 'The Index',
    spaPath : 'theindex',
  },
  events: {
    backgroundImage:
      'https://assets.roguefitness.com/image/upload/v1614175382/Rogue%20App%20Dashboard/profile-rogue-events-bg_bgid9j.png',
    buttonText: 'View Rogue Equipped Events',
    description:
      'See more content about world-class athletic strength events using Rogue Fitness equipment.',
    header  : 'Rogue Equipped Events',
    spaPath : 'theindex/events',
  },
  gyms: {
    backgroundImage:
      'https://assets.roguefitness.com/image/upload/v1614175382/Rogue%20App%20Dashboard/profile-rogue-events-bg_bgid9j.png',
    buttonText: 'View Rogue Equipped Gyms',
    description:
      'See more content about facilities using Rogue Fitness equipment.',
    header  : 'Rogue Equipped Gyms',
    spaPath : 'rogue-equipped-gyms',
  },
}

export const programmingBanner = {
  backgroundImage:
    'https://assets.roguefitness.com/image/upload/v1614175382/Rogue%20App%20Dashboard/profile-rogue-events-bg_bgid9j.png',
  buttonText        : 'View Programming',
  description       : '',
  header            : 'Iron Game Programming',
  spaPath           : 'account/programming',
  routeNameFallback : 'Documents',
}

const dealsCustomCategory = {
  arrowColor : '#EA0000',
  icon       : 'https://assets.roguefitness.com/image/upload/v1701108481/UI/logos/deals_rbgyzg.png',
  iconStyle  : {
    height : 14,
    width  : 64,
  },
  name  : '',
  style : {
    backgroundColor: '#FFFFFF',
  },
  url: 'deals',
}

const zeusCustomCategory = {
  icon      : 'https://assets.roguefitness.com/f_auto,q_auto,c_fill,g_center,w_109,h_194/UI/logos/zeus_hdonba.png',
  iconStyle : {
    height : 30,
    width  : 20,
  },
  name  : 'Zeus',
  style : {
    backgroundColor : '#FFFFFF',
    paddingVertical : 20,
  },
  url: 'zeus',
}

export const topCustomCategories = {
  USA: [
    dealsCustomCategory,
    { name: 'New Gear', url: 'new-gear' },
    { name: '3 Ships Free', url: '3-ships-free' },
  ],
  CAN: [
    dealsCustomCategory,
    { name: 'New Gear', url: 'new-gear' },
  ],
  EUR: [
    dealsCustomCategory,
    { name: 'New Gear', url: 'new-gear' },
    { name: '3 Ships Free', url: '3-ships-free' },
  ],
  GBR: [
    dealsCustomCategory,
    { name: 'New Gear', url: 'new-gear' },
    { name: '3 Ships Free', url: '3-ships-free' },
  ],
  AUS: [
    dealsCustomCategory,
    { name: 'New Gear', url: 'new-gear' },
    { name: '3 Ships Free', url: '3-ships-free' },
  ],
  APO: [
    dealsCustomCategory,
    { name: 'New Gear', url: 'new-gear' },
  ],
}

export const bottomCustomCategories = {
  USA : [zeusCustomCategory],
  CAN : [],
  EUR : [],
  GBR : [],
  AUS : [],
  APO : [],
}
